import React from "react";

const Loading = () => {
  return (
    <div className="hero">
      <div className="hero-body has-text-centered">
        <h1 className="title">Cargando</h1>
        <h2 className="subtitle">Cargando información</h2>
      </div>
    </div>
  );
};

export default Loading;
